import { __rest } from "tslib";
import React, { Fragment, useMemo, useState } from 'react';
import { useTheme } from '../../../../../theme';
import { useTranslation } from 'react-i18next';
import { CdnIcon } from '@shared/ui';
import ModalX from '../../../../../BaseComponents/ModalX';
import cn from 'classnames';
import { useDirections } from '../../hooks';
import DropdownDirections from '../DropdownDirections/DropdownDirections';
import ModalFullscreen from '../../../../../ModalFullscreen';
const MobileDirections = ({ cities }) => {
    var _a, _b;
    const { MobileDirections: css } = useTheme('TravellerForm');
    const { t } = useTranslation('Traveller');
    const _c = useDirections(cities), { fields } = _c, model = __rest(_c, ["fields"]);
    const [selectedDirection, setSelectedDirection] = useState(null);
    const [citiesModal, setCitiesModal] = useState(false);
    const direction = useMemo(() => fields.find(field => field.arrayFieldName === selectedDirection), [
        fields,
        selectedDirection
    ]);
    return (React.createElement("div", { className: css.directions },
        React.createElement("div", { className: css.menu }, fields.map((field, index) => (React.createElement(Fragment, { key: field.arrayFieldName },
            React.createElement("div", { className: css.menu__item, onClick: () => setSelectedDirection(field.arrayFieldName) },
                React.createElement("div", { className: css.menu__labelWrapper },
                    React.createElement(CdnIcon, { icon: field.icon, className: css.flightIcon }),
                    React.createElement("span", null, field.label)),
                React.createElement(CdnIcon, { icon: "Action/Edit", className: css.editIcon })),
            index === 0 && React.createElement("div", { className: css.horizontalLine }))))),
        React.createElement(ModalFullscreen, { classes: {
                paper: css.directionsModal__paper
            }, className: css.directionsModal__content, ignoreClose: false, isOpen: !!direction, onClose: () => setSelectedDirection(null), title: React.createElement("div", { className: css.directionsModal__title }, (direction === null || direction === void 0 ? void 0 : direction.label) || '') },
            React.createElement("div", { className: css.directionsModal__directions },
                React.createElement("div", { className: cn(css.directionsModal__header, {
                        [css.directionsModal__header_withLine]: ((_a = direction === null || direction === void 0 ? void 0 : direction.selectedOptions) === null || _a === void 0 ? void 0 : _a.length) > 0
                    }), onClick: () => setCitiesModal(true) },
                    React.createElement("span", null, t('Directions')),
                    React.createElement(CdnIcon, { className: css.addIcon, icon: "Action/Add" })), (_b = direction === null || direction === void 0 ? void 0 : direction.selectedOptions) === null || _b === void 0 ? void 0 :
                _b.map(option => (React.createElement("div", { key: option.value, className: css.directionsModal__selectedDirections, onClick: () => model.deleteOption(direction === null || direction === void 0 ? void 0 : direction.arrayFieldName, option) },
                    React.createElement("span", null, option.label),
                    React.createElement(CdnIcon, { className: css.removeIcon, icon: "Action/Remove" })))))),
        React.createElement(ModalX, { classes: {
                paper: css.dropdownModal__paper,
                closeButton: css.dropdownModal__closeButton,
                content: css.dropdownModal__content
            }, isOpen: citiesModal && !!direction, onClose: () => setCitiesModal(false), noPadding: true }, !!direction && (React.createElement(DropdownDirections, Object.assign({}, model, { field: direction, open: true, forcePopupIcon: false, InputProps: {
                variant: 'labelIn',
                classes: {
                    labelIn: css.dropdownInput__labelIn
                }
            }, classes: {
                root: css.dropdown__root,
                listbox: css.dropdown__listbox,
                paper: css.dropdown__paper,
                popper: css.dropdown__popper,
                option: css.dropdown__option
            } }))))));
};
export default MobileDirections;
